import { createContext, useContext } from "react";

// Alternative previews do not display mandatory badges, including on nested contents.
export const LearningObjectAlternativeContext = createContext(false);

export const useIsAlternativeContent = () => useContext(LearningObjectAlternativeContext);
